import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CareerResultSchema } from '../../../schemas/career-matches';

@Component({
  selector: 'app-result-card',
  imports: [],
  templateUrl: './result-card.component.html',
  styleUrl: './result-card.component.css'
})
export class ResultCardComponent {
  @Input() match_item!: CareerResultSchema;
  @Input() index!: number;
  @Output() bookmarkEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output() cardClickEmitter: EventEmitter<string> = new EventEmitter<string>();

  onClickBookmark() {
    this.bookmarkEmitter.emit(this.index);
  }

  onClickCard(onetCode: string) {
    this.cardClickEmitter.emit(onetCode);
  }
}
